import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import './BuildingControls.css';

export class BuildingControls extends Component {
  static propTypes = {
    prop: PropTypes
  }

  render() {
    return (
      <div>
        <br/>
        <br/>
        <img style={{margin:"0 auto", display:"block", width:"30%"}}src="/images/iPhoneAppScreenshot.png"></img>
        <br/>
        <br/>
        <p class="text-phone">Please download our iPhone application from the <a href='https://itunes.apple.com/us/app/betterspaces-com/id1296340431?mt=8'>App Store</a> </p>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  
})

const mapDispatchToProps = {
  
}

export default connect(mapStateToProps, mapDispatchToProps)(BuildingControls)



// WEBPACK FOOTER //
// ./src/components/BuildingControls.js